import { render, staticRenderFns } from "./report-tabs-actions.vue?vue&type=template&id=0593cdba&"
import script from "./report-tabs-actions.vue?vue&type=script&lang=ts&"
export * from "./report-tabs-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports